"use strict";

/* Directives */
_BannerFlowApp.directive("inlineEdit", function () {
    return {
        restrict: "A",
        require: "?ngModel",
        scope: {
            inlineEdit: "&?"
        },
        controller: function ($scope, $attrs) {},
        link: function (scope, element, attrs, ngModel) {
            if (!ngModel) return;

            if (attrs.canRename && attrs.canRename === "false") {
                return;
            }

            var $link = $("<i class='fa fa-pencil edit-link'></i>");
            var $input = null;

            var close = function () {
                if ($input) $input.remove();

                element.show();
            };

            $link.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                renderInput();
            });

            $(element).addClass("inline-edit-element");
            $(element).append($link);

            function renderInput() {
                $input = $("<input spellcheck='false' type='text' />");
                var inputWidth = 100;
                if (ngModel.$viewValue) {
                    inputWidth = Math.max(ngModel.$viewValue.length * 7 + 20, 110);
                }
                $input.width(inputWidth + "px");

                $input.click(function (e1) {
                    e1.stopPropagation();
                    e1.preventDefault();
                });

                $input.keydown(function (e2) {
                    if (e2.keyCode === 27) close();
                    else if (e2.keyCode === 13) {
                        var inputValue = $input.val();
                        if (!inputValue && !element[0].dataset.allowEmpty) return;

                        if (inputValue === "") {
                            inputValue = null;
                        }

                        scope.$apply(function () {
                            ngModel.$setViewValue(inputValue);
                            scope.inlineEdit();
                        });
                        close();
                    }
                });

                $input.blur(function () {
                    close();
                });

                $input.val(ngModel.$viewValue);

                element.after($input);
                $input.focus();
                element.hide();
            }
        }
    };
});
